import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import ReloadIcon from '@components/Icon/Reload'

import MonthYearPicker from '@components/MonthPicker/MonthYearPicker'
import FilterGroup from '@components/FilterGroup'
import { stringifyYearMonth } from '@atheneum/api/dist/lib'
import { Autocomplete, Dropdown } from '@components/Autocomplete'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import Expert from '@components/Icon/Expert'
import MyProjects from '@components/Icon/MyProjects'

class RevenuesFilterPanel extends Component {
  static propTypes = {
    revenuesStore: PropTypes.object
  }

  filterByAtheneumOffice = selectedOffice => {
    const { revenuesStore } = this.props
    const id = selectedOffice.id
    revenuesStore.query.apOffice = id
    revenuesStore.filterResults()
  }

  filterByProjectType = selectedProjectType => {
    const { revenuesStore } = this.props
    const id = selectedProjectType.id
    revenuesStore.query.projectType = id
    revenuesStore.filterResults()
  }

  filterByAccountType = selectedAccountType => {
    const { revenuesStore } = this.props
    revenuesStore.query.accountType = selectedAccountType.id
    revenuesStore.filterResults()
  }

  filterByMonth = date => {
    const { revenuesStore } = this.props
    const formattedDate = stringifyYearMonth(date)
    revenuesStore.query.date = formattedDate
    revenuesStore.filterResults()
  }

  filterByAccProjEmploy = suggestion => {
    const { revenuesStore } = this.props

    if (suggestion) {
      revenuesStore.query.suggestion = suggestion
      revenuesStore.filterResults()
    } else {
      revenuesStore.query.suggestion = null
      revenuesStore.filterResults()
    }
  }

  itemToString = item => {
    if (!item) return ''
    return item.name
  }

  renderItem = item => {
    if (!item) return null

    const icon = this.getItemIcon(item.type)
    const type = item.type.toUpperCase()

    return (
      <div className='suggestion-item'>
        {item.name}
        <div className='suggestion-item-type'>
          <span className='suggestion-item-type-icon'>{icon}</span>
          <span className='suggestion-item-type-text'>{type}</span>
        </div>
      </div>
    )
  }

  getItemIcon = type => {
    if (type === 'account') return <MyProjects />
    if (type === 'project') return <ProjectsIcon />
    if (type === 'employee') return <Expert className='employee' />
    return null
  }

  onClearSearch = () => {
    this.props.revenuesStore.clearSearch()
  }

  render () {
    const {
      atheneumOffices,
      projectTypes,
      accountTypes,
      query,
      autocompleteSuggestions,
      filterResults
    } = this.props.revenuesStore

    return (
      <div
        extrathin
        className='revenues-panel'
        searchTitle='Search and Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup
          inView
          label='Account, project, employee'
          onSearch={filterResults}
        >
          <Autocomplete
            className='search__multiple-options'
            value={query.suggestion}
            loadOptions={autocompleteSuggestions}
            itemToString={this.itemToString}
            renderItem={this.renderItem}
            onChange={this.filterByAccProjEmploy}
          />
        </FilterGroup>
        <FilterGroup inView label='Atheneum office'>
          <Dropdown
            valueIsId
            selectedItem={query.apOffice}
            itemToString={item => item && item.name}
            options={atheneumOffices}
            onChange={this.filterByAtheneumOffice}
          />
        </FilterGroup>
        <FilterGroup inView label='Project type'>
          <Dropdown
            valueIsId
            selectedItem={query.projectType}
            itemToString={item => item && item.name}
            options={projectTypes}
            onChange={this.filterByProjectType}
          />
        </FilterGroup>
        <FilterGroup inView label='Client account type'>
          <Dropdown
            valueIsId
            selectedItem={query.accountType}
            itemToString={item => item && item.name}
            options={accountTypes}
            onChange={this.filterByAccountType}
          />
        </FilterGroup>
        <FilterGroup inView label='Select month'>
          <MonthYearPicker
            monthAndYear={query.date}
            onChange={this.filterByMonth}
          />
        </FilterGroup>
        <div
          className='search-panel-container__title--action'
          onClick={this.onClearSearch}
        >
          <ReloadIcon />
          <span className='row--link m-l-sm'>Clear search</span>
        </div>
      </div>
    )
  }
}

export default inject('revenuesStore')(observer(RevenuesFilterPanel))
